export {
  dictionariesApi,
  useGetClientLanguagesQuery,
  useGetCountriesQuery,
  useGetMedicalDictionaryQuery,
  useGetUsedCitiesQuery,
  useGetUsedCountriesQuery,
  useLazyGetClientLanguagesQuery,
  useLazyGetCountriesQuery,
  useLazyGetMedicalDictionaryQuery,
  useLazyGetUsedCitiesQuery,
  useLazyGetUsedCountriesQuery,
} from './api';

export {
  DictionariesEndpoints,
  MedicalDictionaryType,
  type GetClientLanguagesRequest,
  type GetClientLanguagesResponse,
  type GetCountriesRequest,
  type GetCountriesResponse,
  type GetMedicalDictionaryRequest,
  type GetMedicalDictionaryResponse,
  type GetUsedCitiesRequest,
  type GetUsedCitiesResponse,
  type GetUsedCountriesRequest,
  type GetUsedCountriesResponse,
  type ModelCountry,
  type ModelDictionaryItem,
  type ModelDictionaryResponse,
  type ModelLanguage,
} from './types';
